import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {
    baseUrl = `${baseUrl}/cadastro-domiciliar`

    return {
        list(queryParms = {}) {
            return repository.get(`${baseUrl}/list?${urlUtil.serialize(queryParms)}`)
        },
        index(queryParms = {}) {
            return repository.get(`${baseUrl}/index?${urlUtil.serialize(queryParms)}`)
        },
        datatable(queryParams) {

            return repository.get(`${baseUrl}/datatable?${urlUtil.serialize(queryParams)}`)
        },
        create() {
            return repository.get(`${baseUrl}/create`)
        },
        edit(id) {
            return repository.get(`${baseUrl}/${id}/edit`)
        },
        store(params) {
            return repository.post(`${baseUrl}`, params)
        },
        getUnidades(queryParms) {

            return repository.get(`${baseUrl}/unidade?${urlUtil.serialize(queryParms)}`)
        },
        getInfraestruturas(queryParms) {

            return repository.get(`${baseUrl}/infraestrutura?${urlUtil.serialize(queryParms)}`)
        },
        getEquipes(queryParms) {

            return repository.get(`${baseUrl}/equipe?${urlUtil.serialize(queryParms)}`)
        },
        getOcupacoes(queryParms) {

            return repository.get(`${baseUrl}/ocupacao?${urlUtil.serialize(queryParms)}`)
        },
        getCadastro(queryParms) {

            return repository.get(`${baseUrl}/cadastro?${urlUtil.serialize(queryParms)}`)
        },
    }
}
